import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.documentElement.classList.add("overflow-hidden")
    document.body.classList.add("overflow-hidden")
  }

  disconnect() {
    document.documentElement.classList.remove("overflow-hidden")
    document.body.classList.remove("overflow-hidden")
  }
}
